import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import Pusher from 'pusher-js'
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PusherService {
  private subject: Subject<any> = new Subject<any>();
  acc= JSON.parse(localStorage.getItem(environment.currentUser))
  private pusherClient: Pusher;
  constructor(private https: HttpClient) {

    // this.pusher = new Pusher(environment.pusher.key);
    // this.channel = this.pusher.subscribe('notiEvent');
    this.pusherClient = new Pusher(environment.pusher.key, { cluster: environment.pusher.cluster });
    const channel = this.pusherClient.subscribe(environment.pusher.chanel);
    if(this.acc){
    channel.bind(
      'user_'+this.acc.UserID, (data => {
     
        this.subject.next(data);
      })
    );
    }
  }

  getFeedItems(): Observable<any> {
    return this.subject.asObservable();
  }
}
